import Vue from 'vue'
import Router from 'vue-router'
import Article from '../components/Article'
import Factory from '../components/Factory'
import Report from '../components/Report'
import Pdf from '../components/Pdf'
import Login from '../components/Login'
import Register from '../components/Register'
import Scan from '../components/Scan'
import ArticlesOverview from '../components/ArticlesOverview'
import FactoriesOverview from '../components/FactoriesOverview'
import NotFound from '../components/NotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/scan'
    },
    {
      path: '/scan',
      name: 'Scan',
      component: Scan
    },
    {
      path: '/articles',
      name: 'ArticlesOverview',
      component: ArticlesOverview,
      props: {
        fromFactory: false
      }
    },
    {
      path: '/factories/:factoryCode/articles',
      name: 'FactoryArticles',
      component: ArticlesOverview,
      props: {
        fromFactory: true
      }
    },
    {
      path: '/factories',
      name: 'FactoriesOverview',
      component: FactoriesOverview
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/factory',
      name: 'NewFactory',
      component: Factory
    },
    {
      path: '/factories/:factoryCode',
      name: 'Factory',
      component: Factory
    },
    {
      path: '/article',
      name: 'NewArticle',
      component: Article
    },
    {
      path: '/articles/:articleId',
      name: 'Article',
      component: Article
    },
    {
      path: '/reports',
      name: 'Report',
      component: Report
    },
    {
      path: '/pdf',
      name: 'PDF',
      component: Pdf
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js